import React from 'react';
import PropTypes from 'prop-types';
import RangeItem from './range-item';
import * as styles from './range-item.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
class RangeSelector extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedRange: this.props.selectedRange || this.props.defaultSelectedRange,
      extendToItem: null
    };
    this.getFirstSelectedItem = this.getFirstSelectedItem.bind(this);
    this.getLastSelectedItem = this.getLastSelectedItem.bind(this);
    this.getSelectedPosition = this.getSelectedPosition.bind(this);
    this.addExtendingItem = this.addExtendingItem.bind(this);
    this.removeExtendingItem = this.removeExtendingItem.bind(this);
    this.updateItem = this.updateItem.bind(this);
    this.itemIsActive = this.itemIsActive.bind(this);
    this.itemIsExtending = this.itemIsExtending.bind(this);
    this.itemIsExtendingToRight = this.itemIsExtendingToRight.bind(this);
  }

  // TODO remove UNSAFE_componentWillReceiveProps
  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.selectedRange && nextProps.selectedRange !== this.props.selectedRange) {
      this.setState({
        selectedRange: nextProps.selectedRange
      });
    }
  }
  getFirstSelectedItem() {
    return this.state.selectedRange[0];
  }
  getLastSelectedItem() {
    return this.state.selectedRange[1] ? this.state.selectedRange[1] : this.state.selectedRange[0];
  }
  getSelectedPosition(itemIndex) {
    if (itemIndex === this.getLastSelectedItem()) {
      if (itemIndex === this.getFirstSelectedItem()) {
        return 'single';
      }
      return 'last';
    }
    if (itemIndex === this.getFirstSelectedItem()) {
      return 'first';
    }
    if (this.itemIsActive(itemIndex)) {
      return 'middle';
    }
    return 'none';
  }
  addExtendingItem(extendToItem) {
    this.setState({
      extendToItem
    });
  }
  removeExtendingItem() {
    this.setState({
      extendToItem: null
    });
  }
  updateItem(itemIndex) {
    this.setState(prevState => {
      var selectedRange = prevState.selectedRange.slice();
      if (selectedRange.length === 0) {
        selectedRange = [itemIndex];
      } else if (selectedRange.length === 1) {
        if (selectedRange[0] === itemIndex) {
          selectedRange = [];
        } else if (itemIndex < selectedRange[0]) {
          selectedRange.unshift(itemIndex);
        } else {
          selectedRange.push(itemIndex);
        }
      } else if (itemIndex < selectedRange[0]) {
        selectedRange[0] = itemIndex;
      } else if (itemIndex > selectedRange[1]) {
        selectedRange[1] = itemIndex;
      } else {
        selectedRange = [itemIndex];
      }
      this.props.onChange(selectedRange);
      return {
        selectedRange
      };
    });
  }
  itemIsActive(itemIndex) {
    if (this.state.selectedRange.length === 1) {
      return this.state.selectedRange[0] === itemIndex;
    }
    if (this.state.selectedRange.length === 2) {
      return itemIndex >= this.state.selectedRange[0] && itemIndex <= this.state.selectedRange[1];
    }
    return false;
  }
  itemIsExtending(itemIndex) {
    if (this.state.extendToItem === null) {
      return false;
    }
    var minValue = this.state.selectedRange[0];
    var maxValue = this.state.selectedRange[1] ? this.state.selectedRange[1] : this.state.selectedRange[0];
    return this.state.extendToItem <= itemIndex && itemIndex < minValue || this.state.extendToItem >= itemIndex && itemIndex > maxValue;
  }
  itemIsExtendingToRight(itemIndex) {
    return this.itemIsExtending(itemIndex) && itemIndex > this.getLastSelectedItem();
  }
  render() {
    return ___EmotionJSX("ul", {
      css: styles.rangeItemSelector,
      "aria-label": "Select a range for ".concat(this.props.rangeName)
    }, this.props.items.map((item, index) => ___EmotionJSX(RangeItem, {
      key: item.value,
      hiddenInputId: "filter-".concat(this.props.rangeName, "-").concat(item.value),
      hiddenInputValue: item.value,
      onClick: () => {
        this.updateItem(index);
      },
      onMouseEnter: () => {
        this.addExtendingItem(index);
      },
      onMouseLeave: () => {
        this.removeExtendingItem();
      },
      label: "".concat(item.label),
      hoverLabel: item.abbreviation ? "".concat(item.abbreviation) : "".concat(item.label),
      count: item.count,
      selectedPosition: this.getSelectedPosition(index),
      isExtending: this.itemIsExtending(index),
      isExtendingToRight: this.itemIsExtendingToRight(index),
      rangeName: this.props.rangeName
    })));
  }
}
RangeSelector.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    /* eslint-disable react/no-unused-prop-types */
    value: PropTypes.string.isRequired,
    count: PropTypes.number,
    label: PropTypes.string.isRequired,
    abbreviation: PropTypes.string
    /* eslint-enable react/no-unused-prop-types */
  })).isRequired,
  rangeName: PropTypes.string.isRequired,
  defaultSelectedRange: PropTypes.arrayOf(PropTypes.number),
  selectedRange: PropTypes.arrayOf(PropTypes.number),
  onChange: PropTypes.func
};
RangeSelector.defaultProps = {
  defaultSelectedRange: [],
  onChange: () => {},
  selectedRange: null
};
export default RangeSelector;